export default __webpack_public_path__ + "static/media/class_adults.da3e895b.png";